import {
    StyleSheet
} from "react-native";
import type {
    CollapseRegionDynamicStyleType,
    CollapseRegionStyleType
} from "./type";

export const COLLAPSE_HEIGHT_EPSILON = 0.5;

const stylesheet = StyleSheet.create({
    clip: {
        overflow: "hidden"
    },
    hidden: {
        display: "none"
    }
});

export const useStyles = ({
    opacity,
    height,
    phase
}: CollapseRegionDynamicStyleType) => {
    const styles: {
        region: CollapseRegionStyleType;
    } = {
        region: phase === "closed" ? stylesheet.hidden : undefined
    };

    if(phase === "opening" || phase === "closing") {
        styles.region = [
            stylesheet.clip,
            {
                opacity,
                height
            }
        ];
    }

    return styles;
};
export default stylesheet;
